"use client";

import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { createElement } from "react";
import { useHydratedNow } from "@/hooks/use-hydrated-now";
import { getNotificationIcon, getNotificationSeverity, getSeverityIconColor, getUnreadIndicatorColor } from "@/lib/notification-utils";
import type { NotificationData } from "@domainstack/types";
import { Icon } from "@domainstack/ui/icon";
import { cn } from "@domainstack/ui/utils";
import { formatRelativeTime, toDateTimeAttr } from "@domainstack/utils/date";
interface NotificationCardProps {
  notification: NotificationData;
  onClick?: () => void;
}
export function NotificationCard(t0) {
  const $ = _c(15);
  const {
    notification,
    onClick
  } = t0;
  const IconComponent = getNotificationIcon(notification.type);
  const severity = getNotificationSeverity(notification.type);
  const iconColor = getSeverityIconColor(severity, !!notification.readAt);
  const isUnread = !notification.readAt;
  const now = useHydratedNow();
  const sentAtDateTime = toDateTimeAttr(notification.sentAt);
  const href = notification.trackedDomainId ? `/dashboard?domainId=${notification.trackedDomainId}` : "/dashboard";
  const t1 = notification.id;
  const t2 = isUnread && "bg-accent/20 hover:bg-accent/25";
  let t3;
  if ($[0] !== t2) {
    t3 = cn("block w-full p-3 transition-colors hover:bg-muted/40", t2);
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const t4 = "min-w-0 flex-1";
  let t5;
  if ($[2] !== notification.title) {
    t5 = <p className="text-sm font-medium">{notification.title}</p>;
    $[2] = notification.title;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const t6 = isUnread && <span className={cn("mt-0.5 size-2 shrink-0 rounded-full", getUnreadIndicatorColor(severity))} role="status" aria-label="Unread" />;
  let t7;
  if ($[4] !== t5 || $[5] !== t6) {
    t7 = <div className="flex items-start justify-between gap-2">{t5}{t6}</div>;
    $[4] = t5;
    $[5] = t6;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== notification.message) {
    t8 = <p className="line-clamp-3 text-[13px] text-muted-foreground">{notification.message}</p>;
    $[7] = notification.message;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  const t9 = "mt-1 text-xs text-muted-foreground/75";
  const t10 = sentAtDateTime ? <time dateTime={sentAtDateTime} suppressHydrationWarning={true}>{now ? formatRelativeTime(new Date(sentAtDateTime), now) : "\u2026"}</time> : null;
  let t11;
  if ($[9] !== t10) {
    t11 = <p className={t9}>{t10}</p>;
    $[9] = t10;
    $[10] = t11;
  } else {
    t11 = $[10];
  }
  let t12;
  if ($[11] !== t11 || $[12] !== t7 || $[13] !== t8) {
    t12 = <div className={t4}>{t7}{t8}{t11}</div>;
    $[11] = t11;
    $[12] = t7;
    $[13] = t8;
    $[14] = t12;
  } else {
    t12 = $[14];
  }
  return <Link href={href} data-notification-id={t1} onClick={onClick} className={t3}><div className="flex gap-3"><Icon size="sm" variant={iconColor} className="rounded-full">{createElement(IconComponent)}</Icon>{t12}</div></Link>;
}